import ProductListPriceProvider from './hooks/useProductListPrice';

import { ProductListPriceProps } from './@types/ProductListPriceProps';

const ProductListPrice = (props: ProductListPriceProps) => (
	<ProductListPriceProvider {...props}>
		<span
			data-selection={props.componentId}
			className={`listPrice listPrice--${props.blockClass} vtex-product-price-1-x-listPrice vtex-product-price-1-x-listPrice--${props.blockClass}`}
		>
			<span
				className={`listPriceValue listPriceValue--${props.blockClass} vtex-product-price-1-x-listPriceValue strike vtex-product-price-1-x-listPriceValue--${props.blockClass} strike`}
			>
				<span
					className={`currencyContainer currencyContainer--${props.blockClass} vtex-product-price-1-x-currencyContainer vtex-product-price-1-x-currencyContainer--${props.blockClass}`}
				>
					<span
						className={`currencyCode currencyCode--${props.blockClass} vtex-product-price-1-x-currencyCode vtex-product-price-1-x-currencyCode--${props.blockClass}`}
					>
						R$
					</span>
					<span
						className={`currencyLiteral currencyLiteral--${props.blockClass} vtex-product-price-1-x-currencyLiteral vtex-product-price-1-x-currencyLiteral--${props.blockClass}`}
					>
						&nbsp;
					</span>
					<span
						className={`currencyInteger currencyInteger--${props.blockClass} vtex-product-price-1-x-currencyInteger vtex-product-price-1-x-currencyInteger--${props.blockClass}`}
					>
						25
					</span>
					<span
						className={`currencyDecimal currencyDecimal--${props.blockClass} vtex-product-price-1-x-currencyDecimal vtex-product-price-1-x-currencyDecimal--${props.blockClass}`}
					>
						,
					</span>
					<span
						className={`currencyFraction currencyFraction--${props.blockClass} vtex-product-price-1-x-currencyFraction vtex-product-price-1-x-currencyFraction--${props.blockClass}`}
					>
						00
					</span>
				</span>
			</span>
		</span>
	</ProductListPriceProvider>
);

export default ProductListPrice;
